import { useContext, useEffect, useState } from 'react';

import { CustomerMetricsContext, useUserInfo } from '@moniebook-web/utils';
import { getSDK } from '@web-platform/cx-metrics-browser';
import { useLocation } from 'react-router';

export function MixpanelPageViews() {
    const [mixpanel, setMixpanel] = useState<{
        track_pageview(
            props: Record<string, string | number | undefined>,
        ): void;
    }>();
    const location = useLocation();
    const { currentBusiness } = useUserInfo();
    const { isReady } = useContext(CustomerMetricsContext);

    useEffect(() => {
        if (!isReady) return;

        getSDK('mixpanel').then(setMixpanel).catch(console.error);
    }, [isReady]);

    useEffect(() => {
        if (!mixpanel) return;

        mixpanel.track_pageview?.({
            business_id: currentBusiness?.id,
            url: location.pathname,
            path: location.pathname,
            search: location.search,
        });
    }, [location, mixpanel, currentBusiness?.id]);

    return null;
}
